import { render, staticRenderFns } from "./ServiceToday.vue?vue&type=template&id=48d58d5e&scoped=true&"
import script from "./ServiceToday.vue?vue&type=script&lang=js&"
export * from "./ServiceToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d58d5e",
  null
  
)

export default component.exports